import { useContext, useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { UserContext } from "../../../context/User.context";

import {
  Button,
  Col,
  Form,
  Popconfirm,
  Modal,
  Skeleton,
  Row,
  Image,
  Space,
  Select,
  Breadcrumb,
  Tag,
  Table,
} from "antd";
import TextArea from "antd/es/input/TextArea";

import {
  ExportOutlined,
  ImportOutlined,
  InfoCircleTwoTone,
  HomeOutlined,
  PhoneOutlined,
  UsergroupAddOutlined,
  ApartmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  CarOutlined,
  CheckCircleOutlined,
  BookOutlined,
  ClockCircleFilled,
  ShoppingCartOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import {
  formatDate,
  formatTimeDate,
  isDatePassed,
} from "../../../utils/DateTime";
import { useHttp } from "../../../utils/DataHendler";

export const DetailEvent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code } = useParams();
  const { getData, patchData } = useHttp();

  const { routeFrom } = location.state || {}; //untuk mengetahui params property yang diterima dari page lain

  const { user } = useContext(UserContext);
  const [form] = Form.useForm();

  const [detailData, setDetailData] = useState([]);
  const [dataCardVisitor, setCardVisitor] = useState([]);
  const [cardBackOpen, setcardBackOpen] = useState(false);
  const [cardAddOpen, setcardAddOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);

  const [typeCard, setTypeCard] = useState({});

  useEffect(() => {
    getEvent();
  }, [user, code]);

  const getEvent = async () => {
    setLoading(true);

    try {
      const response = await getData(`/event/${code}`, {}, true);

      const data = response.data;

      setDetailData(data);

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const message = "selamat datang di umkm";

  const convertToInternationalFormat = (number) => {
    if (!number) return "";

    const cleaned = number.replace(/\D/g, ""); // hapus semua karakter non-digit

    if (cleaned.startsWith("0")) {
      return "62" + cleaned.slice(1);
    } else if (cleaned.startsWith("62")) {
      return cleaned;
    }

    return ""; // jika tidak valid
  };

  // LOADING COMPONENT
  const LoadingSkeleton = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center", // Memastikan elemen sejajar secara vertikal
          gap: "20px", // Jarak antara QR Code dan detail pengunjung
          padding: "20px", // Padding untuk memberikan ruang di sekitar konten
        }}
      >
        {/* Skeleton untuk QR Code */}
        <div>
          <Skeleton.Image
            active
            style={{
              width: 130, // Ukuran QR Code
              height: 130,
              borderRadius: "8px", // Rounded corner untuk tampilan modern
            }}
          />
        </div>

        {/* Skeleton untuk Detail Pengunjung */}
        <div
          style={{
            display: "flex",
            flexDirection: "column", // Menyusun detail pengunjung secara vertikal
            gap: "10px", // Jarak antar elemen detail pengunjung
          }}
        >
          {/* Nama Pengunjung */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>

          {/* Nomor Identitas */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>

          {/* Kode Pengunjung */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  // const CardPicked = () => {
  //   return
  // };

  const data = [
    {
      key: "1",
      title: (
        <Space>
          <HomeOutlined style={{ color: "#088395" }} /> name
        </Space>
      ),
      value: detailData.title ?? "-",
    },

    {
      key: "2",
      title: (
        <Space>
          <UsergroupAddOutlined style={{ color: "#088395" }} /> code
        </Space>
      ),
      value: detailData.code ?? "-",
    },

    {
      key: "3",
      title: (
        <Space>
          <ApartmentOutlined style={{ color: "#088395" }} /> Deskripsi
        </Space>
      ),
      value: detailData.description || "-",
    },
  ];

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "40%",
    },
    {
      title: "Info",
      dataIndex: "value",
      key: "value",
      width: "60%",
    },
  ];

  return (
    <>
      <Row justify="center">
        <Col xs={24} sm={22} md={18} lg={14}>
          <>
            <div
              style={{
                marginBottom: "30px",
                borderBottom: "2px solid #088395",
                padding: "10px 15px 0px",
                display: "flex",
                alignItems: "center", // Memastikan elemen sejajar secara vertikal
                justifyContent: "space-between", // Menyusun elemen di antara ruang kosong
              }}
            >
              {/* Breadcrumb */}

              <Breadcrumb style={{ margin: 0 }}>
                <Breadcrumb.Item>
                  <a
                    onClick={() => {
                      navigate("/user/event-admin");
                    }}
                  >
                    Event
                  </a>
                </Breadcrumb.Item>
                <Breadcrumb.Item style={{ fontWeight: "bold" }}>
                  Event Detail
                </Breadcrumb.Item>
              </Breadcrumb>

              {/* Judul "PROFILE VISITOR" */}
              <div
                style={{
                  margin: 0, // Menghapus margin default dari Title
                  textAlign: "right", // Memastikan teks rata kanan
                  color: "#088395", // Warna teks sesuai tema
                  fontWeight: "bold", // Membuat teks lebih tebal
                }}
              >
                Event Detail
              </div>
            </div>
            {loading ? (
              <LoadingSkeleton />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between", // Agar item kiri-kanan berjauhan
                    alignItems: "start", // Rata tengah secara vertikal
                    width: "100%",
                    padding: "20px 0",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  {/* Bagian QR Code & Detail Part */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {/* Detail Part Type & Code */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <Image
                        src={detailData.top_image}
                        alt={detailData.title}
                        width="100%"
                        height={300}
                        style={{ objectFit: "cover", borderRadius: 8 }}
                      />
                    </div>
                  </div>

                  {/* Tombol Inspection di luar wrapper barcode & detail */}
                  <Button
                    onClick={() => {
                      // navigate(`/user/inspection/${detailData.id}`);
                      navigate(`/user/editevent/${detailData.id}`);
                    }}
                    // style={{

                    //   borderColor: "#25D366",
                    //   color: "white",
                    //   fontWeight: "bold",
                    // }}
                  >
                    Update
                  </Button>
                </div>

                <Table
                  dataSource={data}
                  columns={columns}
                  pagination={false}
                  bordered
                  size="small"
                  style={{
                    border: "1px solid #088395",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                />
              </>
            )}
          </>
        </Col>
      </Row>
    </>
  );
};
